module.exports = {
    routes: [
        {
            path: '/students/search/:skill?',
            name: 'students.search',
            component: require('./pages/Search').default,
        },
        {
            path: '/students/:slug',
            name: 'students.profile',
            component: require('./pages/Profile').default,
        },
    ],
};



// WEBPACK FOOTER //
// ./src/taskflex/students/routes.js